<template src="./DemandCountries.html"></template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TopMenu from "@/components/settings/components/topMenu"
import ClientCountrySelect from '@/components/components/ClientCountrySelect';

const { mapGetters, mapActions} = createNamespacedHelpers('settings/demandCountries');

export default {
  name: "DemandCountries",
  components: {
    TopMenu,
    ClientCountrySelect,
  },
  data () {
    return {
      showOverlay: false,
      editSwitch: false,
      isReady: false,
      isChange: false,
      fieldsList: [
        {
          key: 'id',
          label: '-',
          sortable: false,
          tdClass: 'action-cell',
          thClass: 'action-cell'
        },
        {
          key: 'name',
          label: 'Название',
          sortable: true
        },
        {
          key: 'googleCode',
          label: 'Код геотаргетинга',
          sortable: true
        },
      ],
      newGoogleCode: null,
      newCountry: null,
      reComputed: false,
      renderComponent: true,
      searchVal: '',
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'SAVE',
    ]),
    countryChange(countries) {
      this.isChange = true
      this.editSwitch = false

      this.newCountry = countries

    },
    save: function () {
      this.SAVE({th: this});
    },

    editCell: function (id, field) {
      let viewCell = this.$refs.dictionaryTable.$el.querySelectorAll('.t-cell');
      viewCell.forEach((val) => {
        val.style.display = 'block';
      });

      let editCell  = this.$refs.dictionaryTable.$el.querySelectorAll('.edit-cell');
      editCell.forEach((val) => {
        val.style.display = 'none';
      })

      this.$refs['cell_view_' + id +'_'+ field].style.display = 'none';
      if (this.$refs['cell_edit_' + id +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + id +'_'+ field].style.display = 'block';
        this.$refs['cell_edit_' + id +'_'+ field].focus();
      } else {
        this.$refs['cell_edit_' + id +'_'+ field].$el.style.display = 'block';
        this.$refs['cell_edit_' + id +'_'+ field].$el.focus();
      }
    },
    changeCell: function (index, id, field) {
      this.isChange = true
      
      this.$refs['cell_view_' + id +'_'+ field].style.display = 'block';
      if (this.$refs['cell_edit_' + id +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + id +'_'+ field].style.display = 'none';
      } else {
        this.$refs['cell_edit_' + id +'_'+ field].$el.style.display = 'none';
      }
      // add new row
      if (this.SELECTED.length == (index + 1)) {
        let buf = this.SELECTED.splice(0);
        this.$store.commit('settings/demandCountries/SELECTED', buf);
        this.$forceUpdate();
      }
    },
    removeRow: function (id) {
      let buf = this.SELECTED.filter((el) => {
        return id != el.id
      })
      this.$store.commit('settings/demandCountries/SELECTED', buf)
      this.isChange = true
    },
    addNew: function () {
      this.SELECTED.push({
        id: this.newCountry.id,
        name: this.newCountry.name,
        googleCode: this.newGoogleCode,
      })
      this.$store.commit('settings/demandCountries/SELECTED', this.SELECTED)
      // clear
      this.newCountry = null
      this.newGoogleCode = null
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
      this.isChange = true
    },
  },
  computed: {
    ...mapGetters([
      'SELECTED',
    ]),
    getCountryData: function () {
      let buf = [];
      for(let key in this.SELECTED) {
        buf.push(this.SELECTED[key])
      }

      let search = this.searchVal.toLowerCase()
      buf = buf.filter((el) => {
        if (search.length == 0)
          return true

        let name = el.name.toLowerCase()
        return name.indexOf(search) !== -1 || (el.googleCode != null && el.googleCode.indexOf(search) !== -1)
      });

      return buf
    },
  },
  watch: {
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('settings') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.currentPage = this.CURRENT_PAGE;
  },
  created() {
    if (Object.keys(this.SELECTED).length === 0) {
      this.GET_DATA({th: this});
    }
  }
}
</script>

<style scoped>
.country-view {
  cursor: pointer;
}
.demand-countries .container-fluid {
  padding: 0;
}
.col-but-add {
  text-align: left;
}
.select-height {
  height: 27px;
}

</style>

<style>
.demand-countries  .multiselect__select, .demand-countries  .multiselect__tags {
  min-height: 30px;
  height: 33px;
}
.demand-countries .multiselect__placeholder {
  line-height: 16px;
}
</style>